import DOMPurify from "dompurify";
import { WORK_ITEM_HREF_RE } from "./workItemRefs";

// Chat messages may be Quill HTML (body_format 'html'). Only the composer's
// formats survive; everything else is stripped before it reaches the DOM.
const ALLOWED_TAGS = ["p", "br", "strong", "b", "em", "i", "u", "s", "strike", "code", "ol", "ul", "li", "a", "span"];
const ALLOWED_ATTR = ["href", "target", "rel", "data-color"];
// An agent's colored words (backend agents notify._html): a span whose data-color is one of these,
// which ChannelThread colors. Any other data-color, or one on another element, goes.
const COLORS = new Set(["red", "orange", "yellow", "green", "blue", "purple", "gray"]);
// Web, mail and phone links, plus the #task-… / #order-… links of 📋 chips
// (checked exactly in the hook below).
const ALLOWED_URI_REGEXP = /^(?:https?:|mailto:|tel:|#(?:task|order)-[A-Za-z0-9_-]+$)/i;

let hooked = false;
function ensureHook() {
  if (hooked) return;
  DOMPurify.addHook("afterSanitizeAttributes", (node) => {
    if (node.hasAttribute && node.hasAttribute("data-color")
        && (node.tagName !== "SPAN" || !COLORS.has(node.getAttribute("data-color")))) {
      node.removeAttribute("data-color");
    }
    if (node.tagName !== "A" || !node.getAttribute("href")) return;
    const href = node.getAttribute("href");
    if (href.startsWith("#")) {
      // A 📋 chip opens its card in the thread; any other #link goes.
      if (WORK_ITEM_HREF_RE.test(href)) {
        node.removeAttribute("target");
        node.removeAttribute("rel");
      } else {
        node.removeAttribute("href");
      }
      return;
    }
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener noreferrer");
  });
  hooked = true;
}

export function sanitizeMessageHtml(html) {
  ensureHook();
  return DOMPurify.sanitize(String(html || ""), { ALLOWED_TAGS, ALLOWED_ATTR, ALLOWED_URI_REGEXP });
}

export function htmlToPlainText(html) {
  const div = document.createElement("div");
  div.innerHTML = sanitizeMessageHtml(String(html || "").replace(/<\/(p|li)>/gi, "</$1>\n").replace(/<br\s*\/?>/gi, "\n"));
  return (div.textContent || "").replace(/ /g, " ").replace(/\n{2,}/g, "\n").trim();
}

export function isBlankHtml(html) {
  return htmlToPlainText(html).trim() === "";
}

export function messagePlainText(message) {
  if (!message) return "";
  return message.body_format === "html" ? htmlToPlainText(message.body) : String(message.body || "");
}
